import React from "react";
import { Link } from "react-router-dom";

const HeroOne = ({ companyName, phone, data , onButtonClick,logo}) => {
  const formatPhoneNumber = (number) => {
    // Remove non-numeric characters
    return number.replace(/[^\d]/g, "");
  };
  // Format the phone number
  const formattedNumber = formatPhoneNumber(phone);
  const whatsappURL = `https://wa.me/1${formattedNumber}`;
  const calUrl = `tel:${formattedNumber}`;
  return (
    <div
      className="hero-wrapper hero-1"
      id="hero"
      style={{ backgroundImage: `url('${data.image ? data.image : "assets/img/hero/Image_4.png"}')` }}
    >
      <div className="container">
        <div className="row">
            <div className="col-xl-12" id="topLogo">
            <img
                src={logo ? logo : "assets/img/hero/test3.png"}
                style={{ objectFit: "cover" }}
              />
            </div>
        </div>
        <div className="row flex">
          <div className="col-xl-6">
            <div className="hero-style1">
              <span className="sub-title text-white">{companyName}</span>
              <h1 className="hero-title text-white">{data?.title}</h1>
              <p className="hero-text text-white">{data?.subtitle}</p>
              <div className="btn-group">
                <Link to="#" className="btn" onClick={onButtonClick}>
                  {data?.btn_text_1}
                </Link>
                <Link
                  to={whatsappURL}
                  className="btn style-border"
                  target="_blank"
                >
                  {data?.btn_text_2}
                </Link>
                <Link
                  to={calUrl}
                  className="btn"
                  target="_blank"
                >
                  {data?.btn_text_3}
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="hero-thumb text-center">
              <img
                src={data.main_image ? data.main_image : "assets/img/hero/test3.png"}
                alt="Fixturbo"
                style={{ width: "635px", height: "417px", objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroOne;
